<template>
  <div style="background-color:#F0F8FA;width: 100%;height:1000px;">
    <div class="top">
      <div class="border"></div>
      <div class="all"
           style="background-color: white">
        <ul style="height: 400px;width: 100%"
            class="information">
          <li>
            <div class="name">用户类型</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">分组</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">角色</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">职位</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">用户名</div>
            <input type=""
                   name="">
          </li>
          <li>
            <div class="name">邮箱</div>
            <input type=""
                   name="">
          </li>
          <li>
            <div class="name">公司/经销商</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">在职状态</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">品牌</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">网点类型</div>
            <select>
              <option>请选择</option>
            </select>
          </li>
          <li>
            <div class="name">离职日期</div>
            <el-date-picker v-model="value1"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </li>
          <li>
            <div class="name"
                 style="text-align: center;margin-top: 6px">加入宝马集<br>团日期</div>
            <el-date-picker v-model="value2"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </li>
          <li>
            <div class="name">所在城市</div>
            <input type=""
                   name="">
          </li>
          <li>
            <div class="name">手机号</div>
            <input type=""
                   name="">
          </li>
        </ul>
        <div class="btn">
          <ul>
            <li><button style="margin-left: 0">查询</button></li>
            <li><button>账号合并</button></li>
            <li><button>导出</button></li>
            <li><button>新建</button></li>
            <li><button>批量导入</button></li>
          </ul>
        </div>
        <div class="table"
             style="margin-left: 50px">
          <el-table :data="tableData"
                    style="width: 100%"
                    max-height="250">
            <el-table-column fixed
                             prop="kind"
                             label="用户类型"
                             width="100">
            </el-table-column>
            <el-table-column prop="name"
                             label="用户名"
                             width="120">
            </el-table-column>
            <el-table-column prop="company"
                             label="公司/经销商"
                             width="200">
            </el-table-column>
            <el-table-column prop="part"
                             label="角色"
                             width="120">
            </el-table-column>
            <el-table-column prop="position"
                             label="职位"
                             width="300">
            </el-table-column>
            <el-table-column prop="group"
                             label="分组"
                             width="120">
            </el-table-column>
            <el-table-column prop="zip"
                             label="用户状态"
                             width="120">
            </el-table-column>
            <el-table-column prop="zip"
                             label="网点类型"
                             width="120">
            </el-table-column>
            <el-table-column prop="zip"
                             label="品牌"
                             width="120">
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="deleteRow(scope.$index, tableData)"
                           type="text"
                           size="small">
                  查看
                </el-button>
                <el-button @click.native.prevent="deleteRow(scope.$index, tableData)"
                           type="text"
                           size="small">
                  修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block"
             style="float: right;margin-top: 20px;margin-right: 30px">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage4"
                         :page-sizes="[5, 10, 15, 25]"
                         :page-size="100"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="50">
          </el-pagination>
        </div>
        <!-- <div class="next">
        <div>上一页</div>
        <div>下一页</div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user',
  data () {
    return {
      tableData: [{
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }, {
        kind: 'Dealer',
        name: '王小虎',
        company: '上海',
        part: '普陀区',
        position: '上海市普陀区金沙江路 1518 弄',
        group: 200333
      }],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      value1: '',
      value2: ''
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log('每页' + this.val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页:' + val)
    }
  }
}
</script>

<style type="text/css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
input,
select {
  display: block;
  width: 130px;
  height: 35px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
select:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
li {
  float: left;
  list-style: none;
}
.top {
  height: 600px;
  width: 100%;
  background-color: #f0f8fa;
}
.top .border {
  height: 50px;
  widows: 100%;
  border-bottom: 1px solid #ccc;
}
.all {
  width: 1200px;
  margin: 0 auto;
  height: 870px;
  padding-top: 50px;
}
.all .information li {
  height: 100px;
  width: 25%;
  padding-right: 70px;
  position: relative;
}
.all .information li div {
  width: 85px;
  margin-top: 11px;
  float: left;
  text-align: right;
}
.all .information select,
.all .information input {
  float: right;
}
.all .btn {
  height: 100px;
  width: 100%;
}
.all .btn ul {
  width: 600px;
  height: 100px;
  float: right;
}
.all .btn li button {
  height: 40px;
  width: 90px;
  margin-left: 35px;
  background-color: #4ba4dd;
  color: white;
  border: 1px solid #4ba4dd;
  border-radius: 3px;
}
.table ul {
  height: 240px;
  width: 1100px;
  margin-top: 20px;
}
.table ul li {
  width: 1100px;
  height: 40px;
}
.table ul li div {
  float: left;
  width: 100px;
  height: 40px;
  border: 1px solid #c8e7b9;
  border-left: none;
  border-bottom: none;
  line-height: 40px;
  padding-left: 10px;
  font-size: 12px;
}
.table ul .title div {
  font-size: 14px;
  background-color: #f2f2f2;
}
.table ul .body5 div {
  border-bottom: 1px solid #c8e7b9;
}
.next {
  float: right;
  margin-right: 50px;
}
.next div {
  margin-top: 25px;
  height: 35px;
  width: 85px;
  border: 1px solid #d7d7d7;
  float: left;
  line-height: 35px;
  text-align: center;
  border-radius: 3px;
}
</style>
<style type="text/css">
.el-input__inner {
  margin-left: 15px;
  margin-top: -10px;
  position: relative;
  width: 130px;
  padding-left: 0;
}
.el-icon-date:before {
  position: absolute;
  left: 15px;
  top: -10px;
}
.el-input--prefix .el-input__inner {
  padding-left: 28px;
  padding-right: 10px;
}
.el-input__suffix {
  right: -60px;
  top: -10px;
}
.el-pagination .el-select .el-input .el-input__inner {
  width: 80px;
}
.el-pagination__jump .el-input__inner {
  width: 80px;
}
.el-select .el-input .el-select__caret {
  margin-top: 12px;
  margin-right: 8px;
}
.el-pagination__editor.el-input .el-input__inner {
  margin-left: 0;
}
.el-pagination__jump {
  margin-left: 10px;
}
</style>
